// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jO2I","toggleWrap":"styles_toggleWrap__V1h5i","content":"styles_content__2Kn45","selectAreaCode":"styles_selectAreaCode__2gU9H"};